<template>
  <div class="home__brands">
    <h2 class="_special">{{ $t('Onze merken') }}</h2>
    <div class="home__brands__slider">
      <div class="slider__container">
        <template v-if="htmlDataToArray.length > 4">
          <swiper ref="customersSlider" :options="slideOptions">
            <swiper-slide v-for="(slide, index) in htmlDataToArray" :key="index">
              <div v-html="slide"></div>
            </swiper-slide>
          </swiper>
          <div class="slider__controls">
            <div class="slider__control prev" slot="button-prev"></div>
            <div class="slider__control next" slot="button-next"></div>
          </div>
        </template>
        <ul v-else>
          <li v-for="slide in htmlDataToArray" v-html="slide"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';
  import {Prop} from "vue-property-decorator";

  @Component({
    name: 'homeCustomers',
    components: {
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    }
  })

  export default class extends Vue {
    @Prop() private htmlData: string;

    private slideOptions: object = {
      loop: true,
      slidesPerView: 2,
      loopFillGroupWithBlank: true,
      breakpoints: {
        767: {
          slidesPerView: 5
        }
      },
      navigation: {
        nextEl: `.home__brands .next`,
        prevEl: `.home__brands .prev`
      },
    };

    get htmlDataToArray(): Array<string> {
      let arrayOutput = [];
      try {
        const placeholder = document.createElement('div');
        placeholder.insertAdjacentHTML('afterbegin', this.htmlData);
        for (let i = 0; i < placeholder.firstElementChild['children'].length; i++) {
          arrayOutput.push(placeholder.firstElementChild['children'][i].innerHTML);
        }
      } catch (e) {
        console.log(e.error);
      }
      return arrayOutput;
    }
  }
</script>
